export default __webpack_public_path__ + "static/media/assistant.fb3ab237.svg";